export default __webpack_public_path__ + "img/customerservice.8c50be0c.jpeg";